
    module.exports = {
      bytes: 14705,
      height: 79,
      orientation: undefined,
      src: __webpack_public_path__ + "745b6dc39d1848e3c84bfca35d5f576e.svg",
      type: "svg",
      width: 295,
    };
    /**
     * For requires from CSS when used with webpack css-loader,
     * outputting an Object doesn't make sense,
     * so overriding the toString method to output just the URL.
     */
    module.exports.toString = function() {
      return __webpack_public_path__ + "745b6dc39d1848e3c84bfca35d5f576e.svg";
    };
  